import { Box, Typography, useTheme } from '@mui/material';
import { isNumber } from 'lib/typeInference';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'ui/CheckCircle';
import { ErrorCircle } from 'ui/ErrorCircle';
import { DeliveryProgressBar } from './DeliveryProgressBar';

interface DeliverySuccessBoxProps {
    updatedAt?: Date;
    statusString?: string;
    due?: string;
    stage?: 0 | 1 | 2 | 3 | 4 | 5;
}

export const DeliverySuccessBox: React.FC<DeliverySuccessBoxProps> = ({
    updatedAt,
    statusString,
    due,
    stage
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Box p={2}>
            {!isNumber(stage) && (
                <Box width="100%" display="flex" justifyContent="center" mb={1}>
                    <ErrorCircle color={theme.palette.primary.main} />
                </Box>
            )}
            {isNumber(stage) && stage === 5 && (
                <Box width="100%" display="flex" justifyContent="center" mb={1}>
                    <CheckCircle color={theme.palette.primary.main} />
                </Box>
            )}
            <Typography variant="h5" fontWeight={700} align="center">
                {statusString
                    ? t(statusString, { time: moment(updatedAt).format('h:mm a') })
                    : t('DELIVERY_STATUS')}
            </Typography>
            <DeliveryProgressBar stage={stage} />
            {isNumber(stage) && stage < 5 && <Typography align="center">{due}</Typography>}
        </Box>
    );
};
